module.exports = __webpack_public_path__ + "static/media/18.47475963.jpg";